export default __webpack_public_path__ + "static/media/dashboard.4d316d66.png";